function showEventAlert() {

    const originalPush = window?.dataLayer?.push;

    window.dataLayer.push = (...args ) => {

        const push = originalPush.apply(window.dataLayer, args);

        args.forEach( event => event?.is_buendia_event ? alert(JSON.stringify(event)) : null );

        return push;
    };
}


export const analyticsDebugger = {
    showEventAlert
}